module.exports = __webpack_public_path__ + "img/clipboard_without_events.6e3d042d.svg";